import { useState } from "react";
import { Icon } from "../../icons";
import { BuzerIcon } from "../../BuzerIcons";
import { st } from "../../styles.js";
import { useIsNarrow } from "../../hooks/useIsNarrow";

// Leaderboard rank: a medal icon for the top 3, else "N." (or "–").
const MEDAL = { 1: "medal", 2: "medal2", 3: "medal3" };
export function Rank({ rank }) {
  if (MEDAL[rank]) return <BuzerIcon name={MEDAL[rank]} size={18} color="var(--text)" />;
  return <>{rank ? rank + "." : "–"}</>;
}

// Overview stat card with an optional info-tooltip (and an optional leading icon).
export function OvStat({ value, label, tip, icon }) {
  const [open, setOpen] = useState(false);
  const narrow = useIsNarrow();
  // v27 — Redmi ~360px: 3 karty v rade = ~75px na obsah; font sa zmenšuje podľa displeja
  // aj dĺžky hodnoty (5-miestne body, „12/28", „100 %"), nech čísla nepretekajú z karty
  const len = String(value ?? "").length;
  const fs = narrow
    ? (len <= 3 ? 28 : len === 4 ? 24 : len === 5 ? 21 : 18)
    : (len <= 4 ? 32 : len === 5 ? 28 : 24);
  return (
    <div style={{ ...st.ovCard }}>
      {tip && (
        <button type="button" onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }} aria-label={"Čo je " + label}
          style={{ position: "absolute", top: 8, right: 8, width: 20, height: 20, padding: 0, border: "none", background: "transparent", color: "var(--muted)", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", zIndex: 2 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>
        </button>
      )}
      {icon ? (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ display: "inline-flex", flexShrink: 0 }}>{icon}</span>
          <div className="display" style={{ ...st.ovNum, fontSize: fs, whiteSpace: "nowrap" }}>{value}</div>
        </div>
      ) : (
        <div className="display" style={{ ...st.ovNum, fontSize: fs, whiteSpace: "nowrap" }}>{value}</div>
      )}
      <div style={st.ovLabel}>{label}</div>
      {open && (<>
        <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
        <div style={{ position: "absolute", top: "calc(100% + 6px)", left: 0, right: 0, zIndex: 41, background: "var(--ink)", color: "var(--surface)", borderRadius: 10, padding: "9px 11px", fontSize: 12, lineHeight: 1.45, boxShadow: "var(--shadow-lg)" }}>{tip}</div>
      </>)}
    </div>
  );
}

// v23 — pilulka pre filter (zelená výplň keď aktívna, inak obrys) — mock #40
export function FPill({ active, onClick, label, count }) {
  return (
    <button type="button" onClick={onClick} className={`bz-fpill${active ? " bz-fpill--on" : ""}`}>
      {label}{count != null && <span style={{ fontWeight: 800, opacity: active ? 0.8 : 0.5, fontSize: 11 }}>{count}</span>}
    </button>
  );
}

// Profile stat: icon + number + label. `badge` = voliteľný malý trailing indikátor
// (v33 — napr. „dnes už predĺžená" pri sérii, pozri ProfileBody.jsx).
export function ProfStat({ icon, color = "var(--text)", value, label, badge }) {
  return (
    <div style={st.profStat}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 5 }}>
        <Icon name={icon} size={16} color={color} />
        <span className="display" style={st.statNum}>{value}</span>
        {badge}
      </div>
      <div style={st.statLabel}>{label}</div>
    </div>
  );
}
